"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.ExtraHelperService = void 0;
var http_1 = require("../../core/http");
var extra_api_1 = require("./extra.api");
var operators_1 = require("rxjs/operators");
var model_1 = require("./model");
var session_1 = require("../session");
var fetchExtra$;
var fetchExtra = function (sessionId) {
    if (!fetchExtra$) {
        var headers = {
            'X-AVP-Properties': 'Description',
            'X-AVP-PictureTemplates': 'Original|XLarge',
            'X-AVP-DescriptionType': 'text/plain'
        };
        fetchExtra$ = http_1.Http.get(extra_api_1.ExtraApi.get(sessionId), { headers: headers }).pipe(operators_1.share(), operators_1.map(function (res) {
            var roomExtras = Object.keys(res.roomExtras).reduce(function (acc, key) {
                var _a;
                return __assign(__assign({}, acc), (_a = {}, _a[key] = res.roomExtras[key].map(function (r) { return model_1.createExtra(r); }), _a));
            }, {});
            return {
                hotelExtras: res.hotelExtras.map(function (r) { return model_1.createExtra(r); }),
                roomExtras: roomExtras
            };
        }), operators_1.catchError(session_1.SessionService.shouldBeSessionError));
    }
    return fetchExtra$;
};
var resetCacheFetchExtra = function () { return fetchExtra$ = null; };
exports.ExtraHelperService = { fetchExtra: fetchExtra, resetCacheFetchExtra: resetCacheFetchExtra };
//# sourceMappingURL=extra-helper.service.js.map